import { GraphQLSubscription } from '@aws-amplify/api';
import { graphqlOperation, GraphqlSubscriptionResult } from '@aws-amplify/api-graphql';
import {
  QueryWorkOrderArgs,
  SubscriptionWorkOrderAvailableArgs,
  WorkOrder,
  WorkOrderAvailableSubscription,
  WorkOrderQuery,
} from 'API';
import { generateClient } from 'aws-amplify/api';
import { workOrder } from 'graphql/queries';
import { workOrderSubscription } from 'graphql/subscriptions';
import Http from './http';
const API = generateClient();
/**
 * Get an order by orderNumber.
 * @param input - order number.
 * @returns WorkOrderResult
 */
export const getWorkOrder = async (input: QueryWorkOrderArgs): Promise<WorkOrder> => {
  const response = await Http.handleGraphqlOperation<WorkOrderQuery>(workOrder, input);
  return Http.processGraphqlResponse(response.workOrder, 'WorkOrder');
};

/**
 * Listen for a work order ready to print.
 * @param input - order number.
 * @returns A subscription object, not subscribed to anything yet
 */
export const subscribeToWorkOrder = (
  input: SubscriptionWorkOrderAvailableArgs,
  authToken: string
): GraphqlSubscriptionResult<GraphQLSubscription<WorkOrderAvailableSubscription>> => {
  return API.graphql<GraphQLSubscription<WorkOrderAvailableSubscription>>(
    graphqlOperation(workOrderSubscription, input, authToken)
  );
};
